import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { XCircle } from 'lucide-react';
export const FailedSolutionsSection = () => {
  const failures = ['Las aplicaciones de monitoreo gratuito solo te muestran el problema, pero no tienen el poder legal para eliminarlo.', 'Pagar una deuda en colección sin un acuerdo de "borrado" previo solo actualiza la fecha de la mancha, hundiendo tu score por más tiempo.', 'Ignorar las llamadas de los cobradores no soluciona el problema; solo prepara el terreno para una demanda judicial o un embargo de salario.'];
  return <SectionWrapper bg="bg-navy-900" data-id="element-14">
      <h2 className="font-serif text-3xl md:text-4xl font-bold text-center mb-12 text-white" data-id="element-15">
        Por qué lo que has intentado{' '}
        <span className="text-red-400" data-id="element-16">NO funcionó</span>
      </h2>

      <div className="space-y-6" data-id="element-17">
        {failures.map((text, index) => <div key={index} className="flex items-start gap-4 bg-navy-800 p-6 rounded-xl border border-navy-800 hover:border-red-900/30 transition-colors" data-id="element-18">
            <XCircle className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-19" />
            <p className="text-gray-300 text-lg" data-id="element-20">{text}</p>
          </div>)}
      </div>
    </SectionWrapper>;
};